import { Box } from "@mui/material";
import Images, { Loader } from "assets/images/Images";
import Colors from "assets/style/Colors";

export const Preloader = () => {
  return (
    <Box sx={{ bgcolor: Colors.white, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 380, height: '100vh' }}>
      <Box component={"img"} src={Images.preloader} alt={'loader'} />
    </Box>
  );
}

export const CircleLoading = () => {
  return (
    <Box sx={{ display: 'block', position: 'relative', justifyContent: 'center', alignItems: 'center', minHeight: 380, height: 'calc(100vh - 210px)' }}>
      <Box sx={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%)' }}>
        <Loader />
      </Box>
    </Box>
  );
}